import { useTheme } from '@mui/material';
import {
  CcfAppToastMessage,
  CcfTextField,
  useTranslator,
} from '@nice-ccf/ui-controls';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Id, toast } from 'react-toastify';
import ccfCommitmentStyles from './ccf-commitment-form.styles';
import {  commitmentActions,  getScheduledCommitment } from './ccf-commitment.slice';

/**
 * Custom hook to return delete toast
 * @example useRemoveCommitment() 
 */
export const useRemoveCommitment = (
  isNotesRequired: boolean,
  callbackId: number
) => {
  const theme = useTheme();
  const [translate] = useTranslator();
  const dispatch = useDispatch();
  const notesRef = useRef<HTMLInputElement>(null);
  const AppToastContainer = useRef<Id>('');
  const scheduledContact =  useSelector(getScheduledCommitment);

  const styles = ccfCommitmentStyles(theme);

  /**
   * dismiss toast on cancel
   * @example dismissToast()
   */
  const dismissToast = () => {
    dispatch(commitmentActions.removeCommitmentMessageConfirmed(false));
    toast.dismiss(AppToastContainer.current);
  };

  useEffect(() => {
    return () => {
      if(scheduledContact !== null) {
        toast.dismiss(AppToastContainer.current);
      }
    }
  }, []);

  /**
   * delete handler to delete  commitment
   * @example handleRemoveCommitment()
   */
  const handleRemoveCommitment = (callbackId: number) => {
    if ((isNotesRequired && !!notesRef?.current?.value) || !isNotesRequired) {
      const payload = {
        callbackId: Number(callbackId),
        description: String(notesRef?.current?.value),
      };
      // if(scheduledContact?.contactId===callbackId){
      //   dispatch(cancelCommitment(payload));
      // }
      // else{
      //   dispatch(deleteCommitment(payload));
      // }
      dispatch(commitmentActions.removeCommitmentMessageConfirmed(false));
      dispatch(commitmentActions.setIsEditCommitment(false));
      dispatch(commitmentActions.showCommitmentForm(false));
      
      toast.dismiss(AppToastContainer.current);
    }
  };

  /**
   * open remove confirmation handler
   * @example triggerRemoveToast()
   */
  const triggerRemoveToast = () => {
    dispatch(commitmentActions.removeCommitmentMessageConfirmed(true));
    AppToastContainer.current = toast.warn(
      <CcfAppToastMessage
        type="warning"
        titleKey="removeCommitmentConfirmationTitle"
        messageKey={'removeCommitmentConfirmationMsg'}
        primaryBtnText="remove"
        secondaryBtnText="keep"
        triggerPrimaryHandler={() => handleRemoveCommitment(callbackId)}
        triggerSecondaryHandler={() => dismissToast()}
      >
        <CcfTextField
          name="addnotes"
          id="addnotes"
          fullWidth
          placeholder={translate('notes')}
          multiline
          sx={styles.textArea}
          inputRef={notesRef}
          helperText={
            isNotesRequired ? translate('helperTextMessageForNotes') : ''
          }
          FormHelperTextProps={{ style: styles.notesHelperTextStyles }}
        />
      </CcfAppToastMessage>,
      {
        autoClose: false,
        closeButton: false,
        containerId: 'AppToastContainer',
        className: 'removeCommitmentConfirmToast',
      }
    );
  };

  return { triggerRemoveToast };
};
